import axios from "axios";
import queryString from "query-string";
import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import "react-datepicker/dist/react-datepicker.css";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  ctaClickEvent,
  formAbandonmentEvent,
  formFieldErrorEvent,
  formIntermediateEvent,
  formStartEvent,
  formSubmissionFailEvent,
  formSuccessEvent,
} from "../services/adobeDataLayer.js";
import {
  formatAndValidateE164,
  hashValue,
  normalizeEmail,
  setValuesInLocalStorange,
} from "../services/utils.js";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

// import ReCAPTCHA from "react-google-recaptcha";
import { callLSQLapp, encryptBody, getLsqLeadBody } from "../services/lsq.js";
function FormComponent() {
  const navigate = useNavigate();
  let cancelToken;

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    setFocus,
    trigger,
    control,
    setError,
    clearErrors,
    formState: { errors, isValid },
  } = useForm({
    mode: "onBlur", // enables real-time validation
  });

  function showToast(type, message) {
    const toast = document.createElement("div");
    toast.className = `toast ${type}`;
    toast.textContent = message;

    document.getElementById("toastContainer").appendChild(toast);

    setTimeout(() => {
      toast.remove();
    }, 4000); // Auto-dismiss after 4 seconds
  }

  const [email, setEmail] = useState("");
  const [isEmailEmpty, setIsEmailEmpty] = useState();
  const [showSendOtp, setShowSendOtp] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(60);
  const [token, setToken] = useState("");
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [cookies, setCookie] = useCookies();
  const [utmDetails, setUtmDetails] = useState({});
  const [showOtherCompany, setShowOtherCompany] = useState(false);
  const [company, setCompany] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [topCorporate, settopCorporate] = useState("");
  const [companies, setCompanies] = useState([]);
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [hasAbandoned, setHasAbandoned] = useState(false);
  const [otpSentCount, setOtpSentCount] = useState(0);
  const firstOtpSentTimeRef = useRef(null);
  const [lastYearIncome, setLastYearIncome] = useState("");
  const [thankYouTriggered, setThankYouTriggered] = useState(false);
  const [disableApplyBtn, setApplyBtnDisable] = useState(false);

  const [modalShowWA, setModalShowWA] = useState(false);
  const [modalShowCB, setModalShowCB] = useState(false);

  const mobileValue = watch("mobile");
  const employmentType = watch("employmentType");
  const hasITR = watch("hasITR");
  // const companyName = watch("companyName");
  const annualIncome = watch("annualIncome");
  const inputWrapperRef = useRef(null);
  const hasTriggeredFormStart = useRef(false);
  const lastAccessedFieldRef = useRef("");
  const companySelectedRef = useRef(false);

  //cursor
  const fullNameRef = useRef(null);
  const otpRef = useRef(null);

  //Modals for Consent
  function MyModal({ show, onHide, title, children }) {
    return (
      <Modal
        show={show}
        onHide={onHide}
        size="lg"
        dialogClassName="modal-70w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
        className="rb" // ✅ scope modal
        backdropClassName="rb" // ✅ scope backdrop
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          <Button className="rb" onClick={onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  useEffect(() => {
    // if otpVerified is true, do not focus (can't focus disabled field)
    if (!otpVerified) {
      // setFocus waits for RNHF internals and is reliable
      setFocus("fullName");
    }
  }, [otpVerified, setFocus]);

  useEffect(() => {
    if (employmentType !== "self-employed") {
      setLastYearIncome(""); // Clears input display also
    }
  }, [employmentType]);

  useEffect(() => {
    if (employmentType !== "self-employed") {
      // Clear self-employed fields
      setValue("lastYearIncome", "");
      setValue("hasITR", "");
    }

    if (employmentType !== "salaried") {
      // Clear salaried fields
      setValue("companyName", "");
      setCompanyName(""); // ← Also clear local state
      setCompanies([]);
      setValue("otherCompanyName", "");
      setValue("annualIncome", "");
    }
  }, [employmentType, setValue]);

  //Last Accessed Field
  useEffect(() => {
    const resetAccessField = () => {
      lastAccessedFieldRef.current = "";
    };
    window.addEventListener("beforeunload", resetAccessField);
    return () => window.removeEventListener("beforeunload", resetAccessField);
  }, []);

  // React event for input fields
  const handleChange = async (e) => {
    const fieldName = e.target.name || "unknown";
    lastAccessedFieldRef.current = fieldName;
    if (!hasTriggeredFormStart.current) {
      formStartEvent("no fee lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
    setHasAbandoned(false);
  };

  useEffect(() => {
    if (otp.length === 6) {
      handleVerifyOtp();
    }
  }, [otp]);

  // Outside click handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      const wrapper = inputWrapperRef.current;
      if (
        wrapper &&
        !wrapper.contains(event.target) &&
        hasTriggeredFormStart.current &&
        !hasAbandoned
      ) {
        const lastField = lastAccessedFieldRef.current;
        formAbandonmentEvent(
          "no fee lead form",
          "lead generation",
          lastField,
          "details",
        );
        setHasAbandoned(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hasAbandoned]);

  // // Hook to add the event listener for formstart
  // useEffect(() => {
  //   const wrapper = inputWrapperRef.current;

  //   if (wrapper) {
  //     wrapper.addEventListener("input", handleAnyInput);
  //   }

  //   // Cleanup listener
  //   return () => {
  //     if (wrapper) {
  //       wrapper.removeEventListener("input", handleAnyInput);
  //     }
  //   };
  // }, []);

  // const handleAnyInput = () => {
  //   handleFormStart();
  // };
  //   const handleFormStart = () => {
  //     if (!hasTriggeredFormStart.current) {
  //       formStartEvent("no fee lead form", "lead generation", "details");
  //       hasTriggeredFormStart.current = true;
  //     }
  //   };

  // // form Abandonment event
  //   useEffect(() => {
  //     const handleClickOutside = (event) => {
  //       if (
  //         inputWrapperRef.current &&
  //         !inputWrapperRef.current.contains(event.target)
  //       ) {
  //         if (hasTriggeredFormStart.current && !hasAbandoned) {
  //           formAbandonment();
  //         }
  //       }
  //     };

  //     document.addEventListener("mousedown", handleClickOutside);
  //     return () => {
  //       document.removeEventListener("mousedown", handleClickOutside);
  //     };
  //   }, [hasAbandoned]);

  //    const formAbandonment = () => {
  //     const lastField = lastAccessedFieldRef.current;
  //     formAbandonmentEvent("no fee lead form", "lead generation", lastField, "details");
  //     setHasAbandoned(true);
  //   };

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       inputWrapperRef.current &&
  //       !inputWrapperRef.current.contains(event.target)
  //     ) {
  //       formAbandonment();
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  // set Fbp, Fbc, UTM parameters values
  // set Fbp, Fbc, UTM parameters values
  useEffect(() => {
    let retryCount = 0; // Initialize retry counter
    const maxRetries = 5; // Maximum number of retries
    const retryInterval = 3000; // Retry interval in milliseconds

    const fetchCookies = () => {
      const getCookieValue = (cookieName) => {
        return (
          document.cookie
            .split("; ")
            .find((row) => row.startsWith(cookieName))
            ?.split("=")[1] || ""
        );
      };

      const fbpValue = getCookieValue("_fbp");
      const fbcValue = getCookieValue("_fbc");

      // Update state if values are found
      if (fbpValue) setFbp(fbpValue);
      if (fbcValue) setFbc(fbcValue);

      // Retry logic
      if ((!fbpValue || !fbcValue) && retryCount < maxRetries) {
        retryCount++;
        setTimeout(fetchCookies, retryInterval);
      }
    };

    fetchCookies();

    // set UTM parameters
    const getUTMDetails = queryString.parse(window.location.search);

    setUtmDetails(getUTMDetails);
  }, []);

  //OTP Button
  useEffect(() => {
    const isValidMobile =
      /^[6-9]\d{9}$/.test(mobileValue) &&
      !/^(\d)\1{9}$/.test(mobileValue) &&
      !/^(\d{2})\1{4}$/.test(mobileValue);
    setShowSendOtp(isValidMobile);
  }, [mobileValue]);

  // Timer countdown
  useEffect(() => {
    if (otpSent && timer > 0 && !otpVerified) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [otpSent, timer, otpVerified]);

  // useEffect(() => {
  //   if (Object.keys(errors).length > 0) {
  //     triggerFormErrorEvent(errors);
  //   }
  // }, [errors]);

  //to handle form error events
  useEffect(() => {
    const handleErrorEvent = (e) => {
      if (hasTriggeredFormStart.current) {
        handleFormFieldErrorEvent(e.detail);
      }
    };

    window.addEventListener("formErrorEvent", handleErrorEvent);

    return () => {
      window.removeEventListener("formErrorEvent", handleErrorEvent);
    };
  }, []);

  const handleFormFieldErrorEvent = (errorData) => {
    formFieldErrorEvent(errorData);
  };

  function triggerFormErrorEvent(errors) {
    const flatErrors = {};

    Object.keys(errors).forEach((key) => {
      if (errors[key]?.message) {
        flatErrors[key] = errors[key].message;
      }
    });

    if (Object.keys(flatErrors).length === 0) return; // no error, no event

    const event = new CustomEvent("formErrorEvent", {
      detail: flatErrors,
    });

    window.dispatchEvent(event);
  }

  const onError = async (errors) => {
    if (!hasTriggeredFormStart.current) {
      console.log("Calling formStartEvent");
      await formStartEvent("no fee lead form", "lead generation", "details");

      hasTriggeredFormStart.current = true;
    }

    triggerFormErrorEvent(errors);
  };

  const handleLastFieldFocus = (fieldName) => {
    lastAccessedFieldRef.current = fieldName;
  };

  const OTP_LIMIT = 3;
  const OTP_WINDOW = 10 * 60 * 1000;

  // const handleSendOtp = async (source) => {
  //   if (!mobileValue) return;
  //   if (mobileValue.length === 10) {
  //     try {
  //       // const res = await onSendOtp(mobileValue);
  //        let payload = { mobile: mobileValue, messageType: "otpGeneral" };
  //               let param = { otp: "send", productType: "CC" };
  //               const res = await callLSQLapp(payload, "OTP", param);
  //               if (res.data.message.response.sent) {
  //                  //Trigger AA Form Intermediate Event for OTP Receive
  //                   if (source === "resend") {
  //                     ctaClickEvent("otp:resend", "lead form", "button", 0, "na");
  //                   } else {
  //                     formIntermediateEvent("send", "otp");
  //                   }
  //         showToast('success', 'An OTP has been sent to your Mobile number.');
  //         //alert("An OTP has been sent to your Mobile number.");
  //         setOtpVerified(false);
  //         setTimer(60);
  //         setOtpSent(true);
  //       }
  //     } catch (error) {
  //       showToast('error', 'Error occurred while generating OTP.');
  //       //alert("Error occurred while generating OTP.");
  //     }
  //   }

  // };

  const handleSendOtp = async (source) => {
    if (!mobileValue) return;
    if (mobileValue.length !== 10) return;

    const now = Date.now();

    // Reset window if 10 mins passed since first OTP sent
    if (
      !firstOtpSentTimeRef.current ||
      now - firstOtpSentTimeRef.current > OTP_WINDOW
    ) {
      firstOtpSentTimeRef.current = now;
      setOtpSentCount(0);
    }

    if (otpSentCount >= OTP_LIMIT) {
      showToast(
        "error",
        "You have reached the maximum of 3 OTP sends within 10 minutes.",
      );
      return;
    }

    try {
      let payload = { mobile: mobileValue, messageType: "otpGeneral" };
      let param = { otp: "send", productType: "CC" };
      const res = await callLSQLapp(payload, "OTP", param);

      if (res.data.message.response.sent) {
        // Update count after successful send
        setOtpSentCount((count) => count + 1);

        // Trigger analytics events
        if (source === "resend") {
          ctaClickEvent("otp:resend", "lead form", "button", 0, "na");
        } else {
          formIntermediateEvent("send", "otp");
        }

        showToast("success", "An OTP has been sent to your Mobile number.");

        setTimeout(() => {
          otpRef.current?.focus();
        }, 50);
        setOtpVerified(false);
        setTimer(60);
        setOtpSent(true);
      }
    } catch (error) {
      showToast("error", "Error occurred while generating OTP.");
    }
  };

  const handleVerifyOtp = async () => {
    if (!mobileValue) {
      showToast("error", "Please enter mobile number");
      //alert("Please enter mobile number");
      return;
    }
    if (otp.length === 6) {
      try {
        // const res = await onVerifyOtp(mobileValue, otp);
        // if (res.data.message === "Failure Occured, please check logs") {

        let payload = { mobile: mobileValue, otp: otp };
        let param = { otp: "verify", productType: "CC" };
        const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
        if (
          otpVerifyResponse.data.message ===
          "Failure Occured, please check logs"
        ) {
          showToast("error", "Incorrect OTP");
          //alert("Please enter valid OTP");
        } else {
          setOtpVerified(true);
          setTimer(0);
          formIntermediateEvent("verified", "otp");
          showToast("success", "OTP verified.");
          setFocus("email");
          const tokenValue =
            otpVerifyResponse.data.message.response.dataSent.UniqueID;
          setToken(tokenValue);
        }
      } catch (error) {
        showToast("error", "Error verifying OTP.");
        //alert("Error verifying OTP.");
      }
    }
  };

  let lastFetchedPrefix = ""; // Keep this at module or component level

  const onCompanyChange = async (e) => {
    const inputValue = e.target.value.trim();
    const prefix = inputValue.substring(0, 4).toLowerCase();
    const storageKey = `noFee_${prefix}`;
    setCompany(inputValue);

    const addOthersIfNeeded = (list) => {
      const hasExactMatch = list.some(
        (item) => item.Company_Name.toLowerCase() === inputValue.toLowerCase(),
      );
      if (!hasExactMatch && inputValue.length > 0) {
        return [...list, { Company_Name: "Others", LTF: null }];
      }
      return list;
    };

    // Always filter from localStorage if data is there
    const storedData = localStorage.getItem(storageKey);
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      const filteredData = parsedData.filter((item) =>
        item.Company_Name.toLowerCase().startsWith(inputValue.toLowerCase()),
      );
      const finalData = addOthersIfNeeded(filteredData);
      setCompanies(finalData);
      return;
    }

    // Only proceed to API if:
    // 1. Prefix has 4 or more characters
    // 2. We haven’t fetched this prefix before
    if (prefix.length >= 2 && prefix !== lastFetchedPrefix) {
      if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Cancelled due to new request");
      }

      cancelToken = axios.CancelToken.source();

      try {
        const payload = { company: inputValue };
        const param = { type: "noFee" };

        const response = await callLSQLapp(payload, "MAVIS", param);
        const { Data, Count } = response.data.message;

        if (Count > 0) {
          localStorage.setItem(storageKey, JSON.stringify(Data));
          lastFetchedPrefix = prefix;

          const filteredData = Data.filter((item) =>
            item.Company_Name.toLowerCase().startsWith(
              inputValue.toLowerCase(),
            ),
          );
          const finalData = addOthersIfNeeded(filteredData);
          setCompanies(finalData);
        } else {
          lastFetchedPrefix = prefix;
          setCompanies([{ Company_Name: "Others", LTF: null }]);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error("Company fetch failed:", error);
        }
      }
    } else {
      // Do not hit API — just clear results
      setCompanies([]);
    }
  };

  // const formAbandonment = async () => {
  //   if (hasTriggeredFormStart.current) {
  //     const lastField = lastAccessedFieldRef.current;
  //     formAbandonmentEvent("no fee lead form", "lead generation", lastField, "details");
  //   }
  // };

  // const handleReset = () => {
  //   if (hasTriggeredFormStart.current) {
  //     ctaClickEvent("Reset", "lead form", "button", 0, "na");
  //   }

  //   reset();
  //   setOtp("");
  //   setOtpSent(false);
  //   setOtpVerified(false);
  //   setTimer(60);
  //   setShowSendOtp(false);
  //   setCompanyName("");
  //   setEmail("")
  // };

  async function convertDateFormat(dateStr) {
    const [day, month, year] = dateStr.split("/");
    return `${year}-${month}-${day}`;
  }

  async function calculateAge(dateStr) {
    const birthDate = new Date(dateStr);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  async function Tandc() {
    if (!hasTriggeredFormStart.current) {
      formStartEvent("no fee lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
    if (hasTriggeredFormStart.current) {
      ctaClickEvent(
        "Terms & Conditions",
        "lead form",
        "text link",
        0,
        "https://www.icicibank.com/terms-condition/credit-card-terms-and-conditions.page",
      );
    }
  }

  async function MITandC() {
    if (!hasTriggeredFormStart.current) {
      formStartEvent("no fee lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
    if (hasTriggeredFormStart.current) {
      ctaClickEvent(
        "Most Important Terms & Conditions",
        "lead form",
        "text link",
        0,
        "https://www.icicibank.com/managed-assets/docs/personal/cards/MITC_cc.pdf",
      );
    }
  }

  const onSubmit = async (data) => {
    if (!otpSent && mobileValue.length == 10) {
      showToast("error", "Click on Send OTP to continue.");
      //alert("Click on Sent OTP to continue.");
      return;
    } else if (!otp) {
      showToast("error", "Please enter OTP to continue.");
      //alert("Please enter OTP to continue.");
      return;
    } else if (!otpVerified) {
      showToast("error", "Please verify OTP to continue.");
      //alert("Please verify OTP to continue.");
      return;
    }
    if (otpVerified) {
      setApplyBtnDisable(true);
    }
    setThankYouTriggered(true);
    // additional static fields
    data.token = token;
    data.Product = "creditcards";
    data.ModeOfLead = "landing-page";
    data.CampaignId = "819038";
    data.CompleteUrl = window.location.href;
    data.FBPixelID = fbp;
    data.FBClickID = fbc;
    data.IsAuthorized = "Yes";
    data.pageType = "noFee"; //unique Identifier
    data.User_Agent = navigator.userAgent;
    data.otp = otp;
    const dob = await convertDateFormat(data.date);
    data.dob = dob;
    const age = await calculateAge(dob);
    data.age = age;
    data.topCorporate = topCorporate;
    if (data.companyName === "Others") {
      data.topCorporate = "others";
    }
    data.IpCollegeName = "NA";

    // data.WhatsappConsent = data.WAConsent ? "yes" : "no";
    // data.CreditConsent = data.CBConsent ? "yes" : "no";

    // if (data.employmentType === "salaried") {
    //   if (data.topCorporate === "yes") {
    //     data.IPCustomerCategory = "Top Corporate"
    //     switch (data.annualIncome) {
    //       case "below 2,40,000":
    //         data.CardType = "Empaneled Platinum Credit Card";
    //         break;
    //       case "2,40,000 - 5,99,999":
    //         data.CardType = "Empaneled Coral Credit Card";
    //         break;
    //       case "6,00,000 - 8,99,999":
    //         data.CardType = "Empaneled Coral Credit Card";
    //         break;
    //       case "9,00,000 - 17,99,999":
    //         data.CardType = "Empaneled Rubyx Credit Card";
    //         break;
    //       case "18,00,000 - 47,99,999":
    //         data.CardType = "Empaneled Sapphiro Credit Card";
    //         break;
    //       case "48,00,000 - 2,49,99,999":
    //         data.CardType = "Empaneled Sapphiro Credit Card";
    //         break;
    //       case "2,50,00,000 and above":
    //         data.CardType = "Empaneled Emerald Credit Card";
    //         break;
    //       default:
    //         data.CardType = "";
    //     }
    //   } else if (data.topCorporate === "no" || data.topCorporate === "others") {
    //     if(data.topCorporate === "no"){
    //       data.IPCustomerCategory = "Preferred Company"
    //     }else data.IPCustomerCategory = "BAU";

    //     switch (data.annualIncome) {
    //       case "below 2,40,000":
    //         data.CardType = "";
    //         break;
    //       case "2,40,000 - 5,99,999":
    //         data.CardType = "Platinum Credit Card";
    //         break;
    //       case "6,00,000 - 8,99,999":
    //         data.CardType = "Platinum Credit Card";
    //         break;
    //       case "9,00,000 - 17,99,999":
    //         data.CardType = "Platinum Credit Card";
    //         break;
    //       case "18,00,000 - 47,99,999":
    //         data.CardType = "Coral Credit Card";
    //         break;
    //       case "48,00,000 - 2,49,99,999":
    //         data.CardType = "Coral Credit Card";
    //         break;
    //       case "2,50,00,000 and above":
    //         data.CardType = "Coral Credit Card";
    //         break;
    //       default:
    //         data.CardType = "";
    //     }
    //   }
    // }

    if (data.employmentType === "salaried") {
      const topCorp = data.topCorporate?.toLowerCase();

      const isTopCorp = topCorp === "yes";
      const isPreferred = topCorp === "no";
      const isOthers = topCorp === "others";

      // Set Customer Category
      if (isTopCorp) {
        data.IPCustomerCategory = "Top Corporate";
      } else if (isPreferred) {
        data.IPCustomerCategory = "Preferred Company";
      } else if (isOthers) {
        data.IPCustomerCategory = "BAU";
      } else {
        data.IPCustomerCategory = "";
      }

      // Card mapping
      const empaneledCards = {
        "below 2,40,000": "Empaneled Platinum Credit Card",
        "2,40,000 - 5,99,999": "Empaneled Coral Credit Card",
        "6,00,000 - 8,99,999": "Empaneled Coral Credit Card",
        "9,00,000 - 17,99,999": "Empaneled Rubyx Credit Card",
        "18,00,000 - 47,99,999": "Empaneled Sapphiro Credit Card",
        "48,00,000 - 2,49,99,999": "Empaneled Sapphiro Credit Card",
        "2,50,00,000 and above": "Empaneled Emerald Credit Card"
      };

      const normalCards = {
        "below 2,40,000": "",
        "2,40,000 - 5,99,999": "Platinum Credit Card",
        "6,00,000 - 8,99,999": "Platinum Credit Card",
        "9,00,000 - 17,99,999": "Platinum Credit Card",
        "18,00,000 - 47,99,999": "Coral Credit Card",
        "48,00,000 - 2,49,99,999": "Coral Credit Card",
        "2,50,00,000 and above": "Coral Credit Card"
      };

      // Assign Card Type
      if (isTopCorp) {
        data.CardType = empaneledCards[data.annualIncome] || "";
        data.IpCardName = empaneledCards[data.annualIncome] || "";
      } else if (isPreferred || isOthers) {
        data.CardType = normalCards[data.annualIncome] || "";
        data.IpCardName = normalCards[data.annualIncome] || "";
      } else {
        data.CardType = "";
      }
    }


    if (data.employmentType === "self-employed") {
      const income = Number(data.lastYearIncome);
      data.IPCustomerCategory = "SES";
      data.IpCompanyName = "NA";
      if (income < 240000) {
        data.CardType = "";
      } else if (income >= 240000 && income <= 1799999) {
        data.CardType = "Platinum Credit Card";
        data.IpCardName = "Platinum Credit Card";
      } else if (income >= 1800000) {
        data.CardType = "Coral Credit Card";
        data.IpCardName = "Coral Credit Card"
      } else {
        data.CardType = "";
      }
    }

    //fix company for others
    let companyName = data.companyName;
    if (companyName === "Others") {
      data.companyName = data.otherCompanyName;
      companyName = data.otherCompanyName;
    }

    data.IpCompanyName = companyName;
    // get utm parameteres values
    const utmParamsObj = queryString.parse(window.location.search);
    // console.log(utmParamsObj);
    for (const [key, value] of Object.entries(utmParamsObj)) {
      // console.log("key", { key: value });
      data[key] = value;
    }

    const isSalariedAndLowIncome =
      data.employmentType === "salaried" &&
      data.annualIncome === "below 2,40,000";

    const isSelfEmployedAndLowIncome =
      data.employmentType === "self-employed" &&
      Number(data.lastYearIncome) < 300000;

    const isSelfEmployedNoITR =
      data.employmentType === "self-employed" &&
      Number(data.lastYearIncome) >= 300000 &&
      hasITR === "no";

    data.Eligible =
      isSalariedAndLowIncome ||
        isSelfEmployedAndLowIncome ||
        isSelfEmployedNoITR
        ? "No"
        : "Yes";

    if (data.Eligible === "No") {
      data.IPCustomerCategory = "Not Eligible"
      data.IpCardName = "Not Eligible";
      data.IpCompanyName = "Not Eligible";
      data.IpCollegeName = "Not Eligible"
    }





    // const isNoteligible =
    //   isSalariedAndLowIncome || data.employmentType === "self-employed";

    // data.Eligible = isNoteligible ? "No" : "Yes";

    if (data.mobile && data.email) {
      const formattedMobile = formatAndValidateE164(data.mobile);
      const formattedEmail = normalizeEmail(data.email);
      const hashedMobile = await hashValue(formattedMobile);
      data.hashedMobile = hashedMobile
      const hashedEmail = await hashValue(formattedEmail);
      data.hashedEmail = hashedEmail;
      setValuesInLocalStorange("userData", hashedEmail, hashedMobile);
      console.log(localStorage.getItem("userData"), "userData");
    }
    localStorage.setItem("data", JSON.stringify(data));
    const formData1 = JSON.parse(localStorage.getItem("data"));
    const mergedObject = { ...formData1, ...data, ...utmDetails };
    console.log("Form submitted:", mergedObject);

    let payload = {
      mobile: data.mobile,
      otp: data.otp,
      formdata: getLsqLeadBody(data),
    };
    let param = { productType: "CC" };
    console.log("getLsqLeadBody(data)", getLsqLeadBody(data))
    const encryptedPayload = await encryptBody(payload);
    let createLeadResp = await callLSQLapp(encryptedPayload, "CREATE", param);
    if (createLeadResp.data.message !== "Failure occured , please check logs") {
      let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
      console.log("leadID", leadid);

      const isSalaried = data.employmentType === "salaried";
      const isSelfEmployed = data.employmentType === "self-employed";


      // Prepare event payload
      const eventPayload = isSalaried
        ? {
          employmentType: data.employmentType,
          company: data.companyName,
          annualIncome: data.annualIncome,
        }
        : {
          employmentType: data.employmentType,
          income: data.lastYearIncome,
          ITRStatus: hasITR,
        };

      // Call form success event
      formSuccessEvent(
        "No fee lead form",
        eventPayload,
        "lead generation",
        "thank you",
        true,
      );

      // Set localStorage type based on eligibility and employmentType

      // 1 - Not eligible (salaried and low income, self employed and low income, self employed with high income but no ITR)
      // 2 - eligible but self employed, not salaried
      // 3 - eligible and salaried
      if (data.Eligible === "Yes") {
        localStorage.setItem("type", isSalaried ? 3 : 2);
        // localStorage.setItem("type", 3);
      } else {
        localStorage.setItem("type", 1);
      }

      // Navigate to thank you page
      navigate(`/thankyou?id=${leadid}`);
    } else {
      formSubmissionFailEvent();
      setApplyBtnDisable(false);
      showToast("error", "Error Occured, Please try again after sometime");
    }

    // if (data.employmentType === "salaried") {
    //   // For salaried, use selected annualIncome directly
    //   localStorage.setItem("type", 3);
    //   navigate("/thankyou")
    //   return;

    // } else if (data.employmentType === "self-employed") {
    //   const income = parseInt(data.lastYearIncome.replace(/[^0-9]/g, ""));
    //   if (income >= 1800000) {
    //     localStorage.setItem("type", 2);
    //   } else if (income >= 900000 && income <= 1799999) {
    //     localStorage.setItem("type", 2);
    //   } else if (income >= 300000 && income <= 899999) {
    //     localStorage.setItem("type", 2);
    //   } else {
    //     localStorage.setItem("type", 1);
    //     navigate("/thankyou")
    //     return;
    //   }
    // }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit, onError)} id="myForm">
      <h3>Fill the form below</h3>
      <div className="px-3" ref={inputWrapperRef}>
        {/* Full Name */}
        <div className="input_wrapper">
          <input
            type="text"
            id="name"
            placeholder="Full Name"
            disabled={otpVerified}
            ref={fullNameRef}
            onFocus={() =>
              handleLastFieldFocus && handleLastFieldFocus("fullName")
            }
            {...register("fullName", {
              required: "Full name is required",
              pattern: {
                value: /^[a-zA-Z\s]+$/,
                message: "Only alphabets and spaces allowed",
              },
            })}
            onInput={(e) => {
              handleChange(e);
              e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
            }}
          />

          {errors.fullName && (
            <span className="error">{errors.fullName.message}</span>
          )}
        </div>

        {/* Mobile Number */}
        <div className=" otp_wrapper input_wrapper">
          <div className="d-flex align-items-center gap-2 ">
            <input
              type="text"
              id="mobile"
              placeholder="Mobile Number"
              disabled={otpVerified}
              onFocus={() => handleLastFieldFocus("Mobile")}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={10}
              {...register("mobile", {
                required: "Mobile number is required",
                validate: (value) => {
                  if (!/^[6-9]\d{9}$/.test(value)) return "Enter a valid mobile number";
                  if (/^(\d)\1{9}$/.test(value)) return "Enter a valid mobile number";
                  if (/^(\d{2})\1{4}$/.test(value)) return "Enter a valid mobile number";
                  return true;
                },
              })}
              onInput={(e) => {
                handleChange(e);
                const val = e.target.value.replace(/\D/g, "").slice(0, 10);
                if (val.length > 0 && !/^[6-9]/.test(val)) {
                  e.target.value = "";
                  setError("mobile", { type: "manual", message: "Enter a valid mobile number" });
                  return;
                }
                e.target.value = val;
                if (val.length === 10 && (/^(\d)\1{9}$/.test(val) || /^(\d{2})\1{4}$/.test(val))) {
                  setError("mobile", { type: "manual", message: "Enter a valid mobile number" });
                } else {
                  clearErrors("mobile");
                }
              }}
            />
            {showSendOtp && (
              <div className="input_wrapper">
                {otpVerified ? (
                  <button
                    type="button"
                    className="resend otp-verified"
                    id=""
                    disabled
                  >
                    OTP Verified
                  </button>
                ) : (
                  showSendOtp &&
                  !otpSent &&
                  !otpVerified && (
                    <button
                      type="button"
                      className="resend"
                      id="sendOtpBtn"
                      onClick={() => handleSendOtp("send")}
                    >
                      Send OTP
                    </button>
                  )
                )}
              </div>
            )}
          </div>
          {errors.mobile && (
            <span className="error">{errors.mobile.message}</span>
          )}
        </div>

        {/* OTP Field */}
        {otpSent && !otpVerified && (
          <div className="otp_wrapper input_wrapper">
            <div className="d-flex align-items-center gap-2 ">
              <input
                type="text"
                id="otp"
                onFocus={() => handleLastFieldFocus("otp")}
                placeholder="Enter the OTP"
                ref={otpRef}
                value={otp}
                onChange={(e) => {
                  // Remove non-digit characters
                  const onlyDigits = e.target.value.replace(/\D/g, "");

                  // Limit to 6 digits
                  const maxSix = onlyDigits.slice(0, 6);

                  setOtp(maxSix);
                }}
                maxLength={6}
                inputMode="numeric"
              />

              <span className="timer">
                {timer < 10 ? `00:0${timer}` : `00:${timer}`}
              </span>
              {timer <= 0 && (
                <button
                  type="button"
                  className="resend"
                  id="resendBtn"
                  onClick={() => handleSendOtp("resend")}
                >
                  Resend
                </button>
              )}
            </div>
            {errors.otp && <span className="error">{errors.otp.message}</span>}
          </div>
        )}

        <div className="input_wrapper">
          <input
            type="text"
            placeholder="Email"
            id="email"
            autoComplete="off"
            value={email}
            {...register("email", {
              required: "Email is required",
              pattern: {
                value:
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+(\.com|\.net|\.in|\.edu|\.co\.uk|\.ai|\.org)$/,
                message: "Email is required",
              },
              onChange: (e) => {
                const data = e.target.value;
                handleChange(e);
                setEmail(data);

                // Check allowed domain
                const allowedDomains = [
                  ".com",
                  ".net",
                  ".in",
                  ".edu",
                  ".co.uk",
                  ".ai",
                  ".org",
                ];
                const isDomainAllowed = allowedDomains.some((domain) =>
                  data.endsWith(domain),
                );

                if (isDomainAllowed) {
                  setFocus("pan");
                }
              },
            })}
          />

          {/* {email.length > 2 ? (
            !isEmailEmpty ? (
              <datalist id="email-options">
                <option value={`${email}@gmail.com`}></option>
                <option value={`${email}@yahoo.com`}></option>
                <option value={`${email}@rediffmail.com`}></option>
                <option value={`${email}@yahoo.co.in`}></option>
                <option value={`${email}@icloud.com`}></option>
                <option value={`${email}@outlook.com`}></option>
              </datalist>
            ) : null
          ) : null} */}

          {errors.email && (
            <span className="error">{errors.email.message}</span>
          )}
        </div>

        <div className="input_wrapper">
          <input
            type="text"
            id="pan"
            placeholder="PAN Number"
            onFocus={() => handleLastFieldFocus("pan")}
            maxLength={10}
            {...register("pan", {
              required: "PAN number is required",
              pattern: {
                value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                message: "Invalid PAN format",
              },
              onChange: (e) => {
                const value = e.target.value.toUpperCase();
                e.target.value = value;

                // Move focus to DOB if PAN is valid
                const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
                if (panPattern.test(value)) {
                  setFocus("date");
                }
              },
            })}
            onInput={(e) => {
              handleChange(e);
              e.target.value = e.target.value.toUpperCase();
            }}
          />

          {errors.pan && <span className="error">{errors.pan.message}</span>}
        </div>

        <div className="custom-datepicker input_wrapper dob-field">
          <Controller
            control={control}
            name="date"
            rules={{
              required: "Date of birth is required",
              validate: (value) => {
                const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
                if (!match) return "Enter valid Date of Birth";
                const [, dayStr, monthStr, yearStr] = match;
                const day = parseInt(dayStr, 10);
                const month = parseInt(monthStr, 10);
                const year = parseInt(yearStr, 10);
                if (day < 1 || day > 31) return "Enter valid Date of Birth";
                if (month < 1 || month > 12) return "Enter valid Date of Birth";
                if (year < 1920 || year > 2015) return "Enter valid Date of Birth";
                const dateObj = new Date(year, month - 1, day);
                if (
                  dateObj.getFullYear() !== year ||
                  dateObj.getMonth() + 1 !== month ||
                  dateObj.getDate() !== day
                ) return "Enter valid Date of Birth";
                return true;
              },
            }}
            render={({ field }) => (
              <input
                {...field}
                placeholder="Date of Birth (dd/mm/yyyy)"
                onFocus={() => handleLastFieldFocus("dob")}
                inputMode="numeric"
                maxLength={10}
                className="form-control"
                onChange={(e) => {
                  let value = e.target.value.replace(/\D/g, "");
                  handleChange(e);
                  if (value.length > 2)
                    value = value.slice(0, 2) + "/" + value.slice(2);
                  if (value.length > 5)
                    value = value.slice(0, 5) + "/" + value.slice(5);
                  if (value.length > 10) value = value.slice(0, 10);

                  field.onChange(value);

                  const digits = e.target.value.replace(/\D/g, "").slice(0, 8);
                  const day = parseInt(digits.slice(0, 2), 10);
                  const month = digits.length >= 4 ? parseInt(digits.slice(2, 4), 10) : null;
                  const year = digits.length === 8 ? parseInt(digits.slice(4, 8), 10) : null;

                  let errorMsg = "";
                  if (digits.length >= 2 && (isNaN(day) || day < 1 || day > 31)) {
                    errorMsg = "Enter valid Date of Birth";
                  } else if (month !== null && (isNaN(month) || month < 1 || month > 12)) {
                    errorMsg = "Enter valid Date of Birth";
                  } else if (year !== null) {
                    if (year < 1920 || year > 2015) {
                      errorMsg = "Enter valid Date of Birth";
                    } else {
                      const dateObj = new Date(year, month - 1, day);
                      if (
                        dateObj.getFullYear() !== year ||
                        dateObj.getMonth() + 1 !== month ||
                        dateObj.getDate() !== day
                      ) errorMsg = "Enter valid Date of Birth";
                    }
                  }

                  if (errorMsg) {
                    setError("date", { type: "manual", message: errorMsg });
                  } else {
                    clearErrors("date");
                  }
                }}
                onBlur={async (e) => {
                  field.onBlur(); // important for react-hook-form to mark as touched

                  const rawValue = e.target.value;
                  if (!/^\d{2}\/\d{2}\/\d{4}$/.test(rawValue)) return;

                  try {
                    const [day, month, year] = rawValue.split("/");
                    const dob = `${year}-${month}-${day}`;
                    const birthDate = new Date(dob);

                    const today = new Date();
                    let age = today.getFullYear() - birthDate.getFullYear();
                    const m = today.getMonth() - birthDate.getMonth();
                    if (
                      m < 0 ||
                      (m === 0 && today.getDate() < birthDate.getDate())
                    ) {
                      age--;
                    }
                    console.log(age);
                    if (age <= 22 || age >= 55) {
                      console.log(age);
                      showToast(
                        "error",
                        "Thank you for your interest. This credit card offering is currently not available for your age group. We appreciate your understanding and look forward to serving you with other relevant products.",
                      );
                      // Clear the DOB field
                      setTimeout(() => {
                        setValue("date", "");
                      }, 2000);
                    }
                  } catch (err) {
                    // Optional: show a fallback error
                  }
                }}
                onKeyDown={(e) => {
                  const allowedKeys = [
                    "Backspace",
                    "ArrowLeft",
                    "ArrowRight",
                    "Tab",
                    "Delete",
                  ];
                  if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                    e.preventDefault();
                  }
                }}
              />
            )}
          />

          {errors.date && <span className="error">{errors.date.message}</span>}
        </div>

        <div className="position-relative input_wrapper">
          <select
            id="occupation"
            {...register("employmentType", {
              required: "Select your profession",
            })}
            defaultValue=""
            onFocus={() => handleLastFieldFocus("employment type")}
            className={`custom-dropdown black-dropdown ${employmentType ? "filled" : "placeholder"
              }`}
          >
            <option value="" disabled>
              Profession
            </option>
            <option value="salaried">Salaried</option>
            <option value="self-employed">Self Employed</option>
          </select>
          <img
            src="dist/img/icons/down.svg"
            className="arrow"
            width="18"
            alt="arrow"
          />
          {errors.employmentType && (
            <span className="error">{errors.employmentType.message}</span>
          )}
        </div>

        {employmentType === "self-employed" && (
          <>
            <input
              type="text"
              id="lastYearIncome"
              onFocus={() => handleLastFieldFocus("lastYearIncome")}
              placeholder="Enter your last year's annual income"
              inputMode="numeric"
              {...register("lastYearIncome", {
                required: "Annual income is required",
                pattern: {
                  value: /^[0-9,]+$/, // allow commas
                  message: "Only numbers are allowed",
                },
                setValueAs: (value) => value.replace(/,/g, ""), // remove commas before storing
              })}
              onChange={(e) => {
                const raw = e.target.value.replace(/\D/g, ""); // remove all non-digits
                const formatted = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // format with commas
                e.target.value = formatted;
                e.target.dispatchEvent(new Event("input", { bubbles: true }));
              }}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault(); // block non-numeric input
                }
              }}
            />

            <div className="position-relative input_wrapper">
              <select
                id="itr"
                {...register("hasITR", {
                  required: "Select ITR option",
                })}
                onFocus={() => handleLastFieldFocus("hasITR")}
                defaultValue=""
                // className={hasITR ? "filled" : "placeholder"}
                className={`custom-dropdown black-dropdown ${hasITR ? "filled" : "placeholder"
                  }`}
              >
                <option value="" disabled>
                  Do you have last year's ITR
                </option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
              <img
                src="dist/img/icons/down.svg"
                className="arrow"
                width="18"
                alt="arrow"
              />
              {errors.hasITR && (
                <span className="error">{errors.hasITR.message}</span>
              )}
            </div>
          </>
        )}

        {employmentType === "salaried" && (
          <>
            <div className="position-relative input_wrapper">
              <input
                className="input-box"
                type="text"
                name="company"
                onFocus={() => handleLastFieldFocus("company")}
                value={companyName}
                placeholder="Enter Company"
                autoComplete="off"
                onBlur={() => {
                  setTimeout(() => trigger("companyName"), 200);
                }}
                {...register("companyName", {
                  required: "This field is required.",
                  validate: () =>
                    companySelectedRef.current ||
                    "Please select a company from the list",
                  onChange: (e) => {
                    const inputVal = e.target.value;
                    companySelectedRef.current = false;
                    setCompanyName(inputVal);
                    onCompanyChange(e);
                    setShowOtherInput(false);
                  },
                })}
              />

              {errors.companyName && (
                <span className="error">{errors.companyName.message}</span>
              )}

              {/* Company dropdown */}
              {companies.length ? (
                <div className="company-selection-container">
                  <ul className="companydropDown">
                    {companies.map((item) => (
                      <li
                        className="company-List"
                        key={item.Company_Name}
                        onClick={() => {
                          companySelectedRef.current = true;
                          if (item.Company_Name === "Others") {
                            setShowOtherInput(true);
                            setCompanyName("Others");
                            settopCorporate("others");
                          } else {
                            setCompanyName(item.Company_Name);
                            settopCorporate(item.Top_Corporates || "others");
                          }
                          setCompanies([]);
                          setValue("companyName", item.Company_Name);
                          trigger("companyName");
                        }}
                      >
                        {item.Company_Name}
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}

              {showOtherInput && (
                <input
                  className="input-box"
                  type="text"
                  onFocus={() => handleLastFieldFocus("otherCompanyName")}
                  placeholder="Enter Other Company Name"
                  {...register("otherCompanyName", {
                    required: "Please enter the company name",
                    onChange: (e) => {
                      // Don't update setCompanyName()
                      setValue("otherCompanyName", e.target.value); // ✅ Only update form value
                    },
                  })}
                />
              )}
            </div>

            <div className="position-relative input_wrapper">
              <select
                id="annualincome"
                {...register("annualIncome", {
                  required: "Select annual income",
                })}
                onFocus={() => handleLastFieldFocus("annualIncome")}
                defaultValue=""
                className={`custom-dropdown black-dropdown ${annualIncome ? "filled" : "placeholder"
                  }`}
              >
                <option value="" disabled>
                  Annual Income
                </option>
                <option value="below 2,40,000">below ₹2,40,000</option>
                <option value="2,40,000 - 5,99,999">
                  ₹2,40,000 - ₹5,99,999
                </option>
                <option value="6,00,000 - 8,99,999">
                  ₹6,00,000 - ₹8,99,999
                </option>
                <option value="9,00,000 - 17,99,999">
                  ₹9,00,000 - ₹17,99,999
                </option>
                <option value="18,00,000 - 47,99,999">
                  ₹18,00,000 - ₹47,99,999
                </option>
                <option value="48,00,000 - 2,49,99,999">
                  ₹48,00,000- ₹2,49,99,999
                </option>
                <option value="2,50,00,000 and above">
                  ₹2,50,00,000 and above
                </option>
              </select>
              <img
                src="dist/img/icons/down.svg"
                className="arrow"
                width="18"
                alt="arrow"
              />
              {errors.annualIncome && (
                <span className="error">{errors.annualIncome.message}</span>
              )}
            </div>
          </>
        )}

        {/* <button
          type="button"
          className="reset"
          id="resetBtn"
          onClick={handleReset}
        >
          Reset Details
        </button> */}

        {/* <div
          className="position-relative input_wrapper d-flex align-items-start mt-3 agreetncwrap"
          style={{ gap: "10px" }}
        >
          <Controller
            name="WAConsent"
            control={control}
            defaultValue={true}
            render={({ field }) => (
              <input
                type="checkbox"
                id="WAConsent"
                // style={{ width: "fit-content" }}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            )}
          />
          <p>
            I confirm that I'm currently residing in India ...
            <Button
              variant="primary"
              className="MIT rb"
              onClick={() => {
                setModalShowWA(true);
                ctaClickEvent(
                  "open: WhatsApp Consent",
                  "lead form",
                  "text link",
                  0,
                  "na",
                );
              }}
            >
              see more
            </Button>
            <MyModal
              show={modalShowWA}
              onHide={() => {
                setModalShowWA(false);
                ctaClickEvent(
                  "close: WhatsApp Consent",
                  "popup",
                  "icon or button",
                  0,
                  "na",
                );
              }}
              title="WhatsApp Remarketing Consent"
            >
              <p>
                I confirm that I am currently residing in India and consent to
                ICICI Bank contacting me on WhatsApp to send promotional
                communications, offers, reminders, and updates relating to
                credit cards offered by ICICI Bank. 
                <br />
                <br />
                This consent shall override any DND/DNC registration for
                WhatsApp communications. I understand that WhatsApp
                communications are subject to WhatsApp's terms and policies, and
                that WhatsApp may process such communications in accordance with
                its policies. 
              </p>
            </MyModal>
          </p>
        </div>
        <div
          className="position-relative input_wrapper d-flex align-items-start mt-3 agreetncwrap"
          style={{ gap: "10px" }}
        >
          <Controller
            name="CBConsent"
            control={control}
            defaultValue={true}
            render={({ field }) => (
              <input
                type="checkbox"
                id="CBConsent"
                // style={{ width: "fit-content" }}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            )}
          />
          <p>
            I hereby authorize ICICI Bank to collect ...
            <Button
              variant="primary"
              className="MIT rb"
              onClick={() => {
                setModalShowCB(true);
                ctaClickEvent(
                  "open: Credit Bureau Consent",
                  "lead form",
                  "text link",
                  0,
                  "na",
                );
              }}
            >
              see more
            </Button>
            <MyModal
              show={modalShowCB}
              onHide={() => {
                setModalShowCB(false);
                ctaClickEvent(
                  "close: Credit Bureau Consent",
                  "popup",
                  "icon or button",
                  0,
                  "na",
                );
              }}
              title="Credit Bureau Consent"
            >
              <p>
                I hereby authorize ICICI Bank to collect, access, and use my
                personal and financial information for the purpose of evaluating
                my credit card application, including credit eligibility and
                underwriting. 
                <br />
                <br />
                I consent to ICICI Bank making inquiries and obtaining
                information from credit bureaus (including but not limited to
                CIBIL) and authorized third-party service providers such as
                NSDL, Karza (for employment verification via EPFO), and Perfios
                (for income and financial analysis).
                <br />
                <br />I also authorize ICICI Bank to use its internal and
                external data sources to conduct necessary credit and
                verification checks, and to store such information as required
                under applicable laws.
              </p>
            </MyModal>
          </p>
        </div> */}

        <div
          className="position-relative input_wrapper d-flex align-items-start mt-3 agreetncwrap"
          style={{ gap: "10px" }}
        >
          <Controller
            name="agreetnc"
            control={control}
            defaultValue={false}
            rules={{
              validate: (value) =>
                value === true ||
                "Please agree to our Terms & Conditions to proceed.",
            }}
            render={({ field }) => (
              <input
                type="checkbox"
                id="agreetnc"
                // style={{ width: "fit-content" }}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            )}
          />

          <p>
            I agree to ICICI Bank's{" "}
            <a
              href="https://www.icici.bank.in/content/dam/icicibank/india/managed-assets/revamp-page-images/docs/pdf/tnc_english.pdf?ITM=nli_documents_cards_creditCard_documents_na_2_na_na_NLI"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => Tandc()}
            >
              Terms & Conditions
            </a>{" "}
            and{" "}
            <a
              href="https://www.icici.bank.in/content/dam/icicibank/india/managed-assets/revamp-page-images/docs/pdf/mitc_cc.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => MITandC()}
            >
              Most Important Terms & Conditions
            </a>{" "}
          </p>
        </div>
        {errors.agreetnc && (
          <span className="error">{errors.agreetnc.message}</span>
        )}

        <button
          id="proceed"
          type="submit"
          className="proceed"
          disabled={disableApplyBtn}
          style={{
            backgroundColor: disableApplyBtn ? "grey" : "",
          }}
        >
          {disableApplyBtn ? "Submitting..." : "Apply Now"}
        </button>
        <div className="toast-container" id="toastContainer"></div>

        {/* {otpVerified && isValid && (
        <button id="proceed" type="submit" className="proceed">
          Proceed
        </button>)} */}
      </div>
    </form>
  );
}

export default FormComponent;
